var VipClaimType = {
    BOTH: 1,
    DEPOSIT_ONLY: 2,
    ROLLOVER_ONLY: 3
}

export { VipClaimType }
